import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import { BrowserRouter as Router} from "react-router-dom";

const theme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      main: blue[400]
    },
    secondary: {
      main: '#f44336',
    },
  },
});

ReactDOM.render(<Router path="/"><MuiThemeProvider theme={theme}><App  />  </MuiThemeProvider></Router>, document.getElementById('root'));
/* ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <App />

, document.getElementById('root')); */

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
